export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const LICENCE_DETAILS = 'licence-details';
export const BILLING_DETAILS = 'billing-details';

export const AMEND_AIRCRAFTLICENCE_APPLICATION = [
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Licence Details',
        fieldList: [
            {
                id: 'licensee-nric',
                label: 'Licensee NRIC',
                type: 'text',
                span: 6
            },
            {
                id: 'registration-no-uen-other',
                label: 'Registration No Uen Other',
                type: 'text',
                span: 6
            },
            {
                id: 'licence-no',
                label: 'Licence No',
                type: 'text',
                span: 6
            },
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Correspondence Person Particulars',
        fieldList: [
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'telNumber',
                label: 'Office Tel Number',
                type: 'text'
            },
            {
                id: 'mobileNo',
                label: 'Mobile No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LICENCE_DETAILS,
        sectionName: 'Correspondence Address',
        fieldList: [
            {
                id: 'addressType',
                label: 'AddressType',
                type: 'text'
            },
            {
                id: 'postalCode',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'blockNo',
                label: 'Block No',
                type: 'text'
            },
            {
                id: 'streetName',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'buildingName',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'floor',
                label: 'Floor',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit',
                type: 'text'
            },
            {
                id: 'foreignAddress1',
                label: 'Foreign Address 1',
                type: 'text'
            },
            {
                id: 'foreignAddress2',
                label: 'Foreign Address 2',
                type: 'text'
            },
            {
                id: 'foreignAddress3',
                label: 'Foreign Address 3',
                type: 'text'
            },
            {
                id: 'zipCode',
                label: 'Zip Code',
                type: 'text'
            }
        ]
    },
    {
        sectionID: BILLING_DETAILS,
        sectionName: 'Billing Person Particulars',
        fieldList: [
            {
                id: 'sameAsCorrespondencePersonParticulars',
                label: 'Same As Correspondence Person Particulars',
                type: 'text'
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'officeTelNumber',
                label: 'Office Tel Number',
                type: 'text'
            },
            {
                id: 'mobileNumber',
                label: 'MobileNumber',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            },
            {
                id: 'notifyViaEmailForFutureLicenceRenewal',
                label: 'Notify Via Email For Future Licence Renewal',
                type: 'text'
            }
        ]
    },
    {
        sectionID: BILLING_DETAILS,
        sectionName: 'Billing Address',
        fieldList: [
            {
                id: 'postalCode',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'blockNo',
                label: 'Block No',
                type: 'text'
            },
            {
                id: 'streetName',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'buildingName',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'floor',
                label: 'Floor',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
